import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import styled from 'styled-components';
import { errorAlert, successAlert } from 'ui-kit/Alert';

import { API_ENDPOINT } from "../../../api/constants";

export default function PasswordRecoveryTool(props) {
  const {
    recoveryKey
  } = props;

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');

  return (
    <Wrapper className={'text-white'} >

      <div className={'my-2'}>
        Password recovery
      </div>

      <div className={'mb-2'}>
        <TextField type="password" placeholder={'New password'} value={password}
          onChange={e => setPassword(e.target.value)} />
      </div>

      <div className={'mb-2'}>
        <TextField type="password" placeholder={'New password one more time'} value={password2}
          onChange={e => setPassword2(e.target.value)} />
      </div>

      <div className={'my-4'}>
        <Button onClick={async () => {
          if (password == undefined || password.length < 6) {
            errorAlert('Password is too short');
            return;
          }
          if (password2 != password) {
            errorAlert('Passwords do not match');
            return;
          }
          if (loading == true) {
            return;
          }
          setLoading(true);
          try {
            await axios.post(`${API_ENDPOINT}/auth/recover/${recoveryKey}`, {
              password: password
            });
            successAlert('Password updated!');
            navigate('/');
          } catch (_exc) {
            errorAlert('Error while updating password');
          }
          setLoading(false);
        }}>
          {loading == true ? '...' : 'Reset password'}
        </Button>
      </div>

    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 420px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 10px;
  @media (max-width: 720px) {
    width: 100%;
  }
`;

const TextField = styled.input`
  background-color: #2f3032 !important;
  border: 1px solid #3d3e3f;
  border-radius: 8px;
  color: white;
  width: 100%;
  font-size: 14px;
  outline: none;
`;

const Button = styled.div`
  background: linear-gradient(90deg, rgba(255, 188, 167, 0.792157) -3.26%, #FF7E55 91.41%);
  border-radius: 10px;
  color: white;
  font-weight: bold;
  padding-left: 15px;
  padding-right: 15px;
  height: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;